module.exports = __webpack_public_path__ + "static/media/car-5.766b90ea.jpg";